import { Center } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";
import { BookCalendar } from "../components";

export const Home = () => {
    return (
        <>
            <Helmet>
                <title>Marginmax | 예약현황</title>
            </Helmet>
            <Center maxW="1600px" width="100%">
                <BookCalendar />
            </Center>
        </>
    );
};
